import React from "react";
import { Circle, User, Users } from "lucide-react";
import { Team } from "@/services/teamService";
import { cn } from "@/lib/utils";
import { Staff as TaskStaff } from "@/types/tasks";

interface AssignedStaffCellProps {
  staffData?: TaskStaff["profile"];
  teamData?: Team;
  className?: string;
}

export const AssignedStaffCell: React.FC<AssignedStaffCellProps> = ({
  staffData,
  teamData,
  className = "",
}) => {
  const teamName = teamData?.name || `Unknown Team`;

  let staffName: string | undefined;
  if (staffData) {
    staffName =
      `${staffData.firstName || ""} ${staffData.lastName || ""}`.trim() ||
      staffData.email;
  }

  const hasTeam = !!teamData;
  const hasStaff = !!staffData;

  const iconSize = 26;
  if (!hasTeam && !hasStaff) {
    return (
      <div className={cn("flex flex-col items-center gap-1", className)}>
        <Circle size={iconSize} />
        <span className="text-sm font-medium text-red-600">Unassigned</span>
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <div className="flex items-center justify-center">
        {hasTeam ? (
          <Users size={iconSize} className="text-muted-foreground" />
        ) : (
          <User size={iconSize} className="text-muted-foreground" />
        )}
      </div>
      <div className="flex flex-col">
        {hasTeam && <span className="text-sm font-medium">{teamName}</span>}
        {hasStaff && (
          <span
            className={cn(
              "text-xs",
              hasTeam ? "text-muted-foreground" : "text-sm font-medium",
            )}
          >
            {staffName}
          </span>
        )}
      </div>
    </div>
  );
};
